function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import { Well } from '../index';
import { getClassNames } from '../../utils';
import { Button, Skeleton } from 'antd';
import { FormLayoutRow } from '../form-layout-row/form-layout-row';
import { NotificationAutoSuggestFields } from '@pushly/models/lib/enums/notification-auto-suggest-fields';
import titleCase from 'title-case';
import { NotificationAutomationSettingsEditor } from './notification-automation-settings-editor';
import { EditOutlined } from '@ant-design/icons';
export var NotificationAutomationSettings = function NotificationAutomationSettings(props) {
  var _domain$notificationA, _ref;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showEditor = _React$useState2[0],
      setShowEditor = _React$useState2[1];

  var domain = props.domain,
      loading = props.loading,
      showInternalEditorAccessFields = props.showInternalEditorAccessFields,
      hideFooter = props.hideFooter,
      wellStyle = props.wellStyle,
      onEditorSubmit = props.onEditorSubmit,
      getAppContainer = props.getAppContainer;
  var wellClassName = wellStyle === 'halo' ? 'type-3' : '';
  var allFields = Object.values(NotificationAutoSuggestFields);
  var domainFields = (_domain$notificationA = domain.notificationAutoSuggestFields) !== null && _domain$notificationA !== void 0 ? _domain$notificationA : null;
  var fields = (_ref = domainFields !== null && domainFields !== void 0 ? domainFields : allFields) === null || _ref === void 0 ? void 0 : _ref.map(function (f) {
    return titleCase(f.replace('_url', ''));
  });

  function render() {
    return /*#__PURE__*/React.createElement(Well, {
      title: "Automation Settings",
      className: "nested ".concat(getClassNames('notif-automation-well', wellClassName)),
      actions: /*#__PURE__*/React.createElement(Button, {
        size: "small",
        onClick: function onClick() {
          return setShowEditor(true);
        },
        disabled: !domain
      }, /*#__PURE__*/React.createElement(EditOutlined, null), /*#__PURE__*/React.createElement("span", null, "Edit")),
      hideFooter: hideFooter !== null && hideFooter !== void 0 ? hideFooter : true
    }, /*#__PURE__*/React.createElement(Skeleton, {
      loading: loading,
      active: true
    }, domain && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Well, {
      title: "Field Suggestions",
      mode: "ghost",
      hideFooter: true
    }, /*#__PURE__*/React.createElement(FormLayoutRow, {
      label: "Fields",
      value: fields.join(', ') || 'Field suggestions disabled'
    })), /*#__PURE__*/React.createElement(NotificationAutomationSettingsEditor, {
      domain: domain,
      getAppContainer: getAppContainer,
      visible: showEditor,
      onEditorSubmit: onEditorSubmit,
      loading: loading,
      onClose: function onClose() {
        return setShowEditor(false);
      },
      showInternalEditorAccessFields: showInternalEditorAccessFields
    }))));
  }

  return render();
};